import anonymizeUserCourseData from './anonymizeUserCourseData';

export default [
  anonymizeUserCourseData,
];
